export const commonStyles = {
  actionButton: { fontWeight: 500, display: 'flex', alignItems: 'center' },
};
